import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-layout-document-list',
  templateUrl: './layout-document-list.component.html',
  styleUrls: ['./layout-document-list.component.scss']
})
export class LayoutDocumentListComponent implements OnInit, OnChanges {
  @Input() inputData: any[] = []; // Input from parent
  reversedData: any[] = [];       // Reversed copy for display

  constructor() { }

  ngOnInit() {
    this.updateReversedData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['inputData'] && this.inputData) {
      this.updateReversedData();
    }
  }

  private updateReversedData() {
    this.reversedData = this.inputData.slice().reverse();
  }
}
